const tours = [
    {
        id: 1,
        title: 'FARMTOGETHER (2 Days 1 Night)',
        images: ['https://media.istockphoto.com/id/827359312/vi/anh/to%C3%A0n-c%E1%BA%A3nh-th%C3%A0nh-ph%E1%BB%91-nha-trang-%E1%BB%9F-vi%E1%BB%87t-nam-t%E1%BB%AB-quan-%C4%91i%E1%BB%83m-m%C3%A1y-bay-kh%C3%B4ng-ng%C6%B0%E1%BB%9Di-l%C3%A1i.jpg?s=612x612&w=0&k=20&c=coljvNU4PTpoKVPfTfuNsHh6u9Xs36BI-o6Pmnhq55I=',
            'https://media.istockphoto.com/id/481599142/vi/anh/beach-in-quy-nhon-city-binh-dinh-province-vietnam.jpg?s=612x612&w=0&k=20&c=zg2PyABfiBPSMiNEX_o-xKjklu3SNlPe4qNPdyjA6_4='
            , 'https://media.istockphoto.com/id/1339640399/vi/anh/hai-ng%C6%B0%E1%BB%9Di-%C4%91%C3%A0n-%C3%B4ng-%C4%91ang-s%E1%BB%ADa-l%C6%B0%E1%BB%9Bi-%C4%91%C3%A1nh-c%C3%A1.jpg?s=612x612&w=0&k=20&c=vc_vFk8VifVQGK3CV4x9VMw3Rjb4H-MmxLndLeYg4iI='
            , 'https://media.istockphoto.com/id/1434918855/vi/anh/b%C3%A3i-bi%E1%BB%83n-c%E1%BB%A7a-m%E1%BB%99t-khu-ngh%E1%BB%89-m%C3%A1t-ch%C3%A2u-%C3%A1.jpg?s=612x612&w=0&k=20&c=rGlFk021jFfIkVgkyP6oayPxLaQp2Fvv3M3LWWttua4='],
        price: '63',
        locations: ['Ponagar Tower', 'Ngoc Hoi Straw Mat Craft Village', 'Lu Cam Pocerlain Craft Village', 'Xom Bong Fishing Village', 'The Nha Trang Institute of Oceanology', 'FBT Happy Farm'],
        details: 'Day 1 \n' +
            '7:30-8:00: Gathering from the accommodation to the Ponagar Tower \n' +
            '8:15-9:00: Visit to the Ponagar Tower from \n' +
            '9:10-9:30: Moving to the boat port on the River Cai from \n' +
            '9:30-11:00:\n  Take a boat tour of the river Cai \n' +
            'Visit the ancient house of Mr. Hai \n' +
            'Collecting coconut and enjoying coconut water\n' +
            'Visit the  Xom Bong fishing village \n' +
            '11:00-11:45: Move to T&T Happy Farm from \n' +
            '12:00-13:00: Lunch\n' +
            '13:00-14:00: Experience of moisturizing feet and washing hair with medicines \n' +
            '14:00-16:00: Participating farming activities ( harvesting vegetables,....)\n' +
            '16:00-18:00:  Participating Cooking class\n' +
            '18:00 to 20:00: Camp fire and dinner with harvested agricultural products.\n' +
            'After 20:00 p.m.: Free time\n' +
            'Day 2\n' +
            '7:00-7:30: Breakfast \n' +
            '7:30-8:00: Move to Craft Village\n' +
            '8:00-9:30 : Visit of the Ngoc Hoi Straw Mat village and Lu Cam Ceramic village\n' +
            '9:30-10:00 : Move to the oceanological institute \n' +
            '10:00-11:00: Visit to oceanology institute\n' +
            'After 11:00: Return to the hotel\n',
        time: '2 Days 1 Night'
    },
    {
        id: 2,
        title: 'MINI FARMTOGETHER (1 Day)',
        images: ['https://media.istockphoto.com/id/1312638550/vi/anh/nha-trang-city-in-sunset.jpg?s=612x612&w=0&k=20&c=Q-O1_XK4vhQi8N-XkWQjtAolB65HHdsHSS7oQD_Vsa8=',
            'https://media.istockphoto.com/id/1410796668/vi/anh/nh%C3%ACn-t%E1%BB%AB-tr%C3%AAn-kh%C3%B4ng-t%C6%B0%E1%BB%A3ng-ph%E1%BA%ADt-l%E1%BB%9Bn-m%C3%A0u-tr%E1%BA%AFng-%E1%BB%9F-ch%C3%B9a-long-s%C6%A1n-%E1%BB%9F-nha-trang-vi%E1%BB%87t-nam.jpg?s=612x612&w=0&k=20&c=ZnNgqfc6bb2_TruHxdiyhwBDNyuyB39Q1bBlGFP-s6k='
            , 'https://media.istockphoto.com/id/1133733993/vi/anh/vi%E1%BB%87t-nam-nha-trang-quang-c%E1%BA%A3nh-s%C3%B4ng-kai-v%C3%A0-th%C3%A0nh-ph%E1%BB%91.jpg?s=612x612&w=0&k=20&c=ZLZWHqMm5qDBTBlLSCfiQlEc1ElYMIJJctO0dY6Oypc='
            , 'https://media.istockphoto.com/id/1467329369/vi/anh/trang-tr%E1%BA%A1i-h%E1%BB%93-t%C3%B4m-c%E1%BB%A7a-th%E1%BB%8B-tr%E1%BA%A5n-v%C4%A9nh-th%C3%A1i.jpg?s=612x612&w=0&k=20&c=AdSvU32C6ZTHOBaqGz6nnAD_lcG02oKeyfuFnfSQ6v4='],
        price: '40',
        locations: ['Ponagar Tower', 'Xom Bong Fishing Village', 'FBT Happy Farm'],
        details: '7:30-8:00: Take the guests from the accommodation to the Ponagar tower \n' +
            '8:15-9:00: Visit the Ponagar tower \n' +
            '9:10-9:30: Move to the boat port at the river Cai\n' +
            '9:30-11:00: Take a boat to visit the rivers \n' +
            'Visit the ancient house of Mr. Hai \n' +
            'Coconut Harvesting and drinking coconut water\n' +
            'Visit the Xom Bong fishing village \n' +
            '11:00-11:45: Move to T&T Happy Farm\n' +
            '12:00-13:00: Lunch from \n' +
            '13:00 to 14:00: Feet soaking and medicinal washing experience from \n' +
            '14:00 to 16:00: Participating farming activities (harvesting vegetables,….)\n' +
            '16:00-18:00: Cooking class \n' +
            '18:00-19:00: Dinner with harvested agricultural products.\n' +
            '19:00-19:45: Returned to the hotel.\n',
        time: '1 Day'
    }

];

export default tours;